import { uniqueId } from 'lodash';
import getBillingModel, { BILLING_MODELS } from '@dashboard/services/getBillingModel';
import { useVariants } from './VariantsContext';

export function getInitialVariantOption(product) {
  return {
    key: uniqueId(),
    name: '',
    image: null,
    status: 'enabled',
    files: [],
    description: '',
    additionalChargeAmount: '',
    discountedFromPrice: '',
    sku: '',
    stock: null,
    // Recurring only when every enabled price is recurring — a mixed product
    // seeds one_time (recurring options are disabled while a one-time price is
    // in scope). Legacy products fall back via getBillingModel.
    type: getBillingModel(product) === BILLING_MODELS.SUBSCRIPTION ? 'recurring' : 'one_time',
  };
}

export function useVariantOption({ variantId, variantOptionId }) {
  const { state } = useVariants();

  const variantOption = state
    .find(variant => variant._id === variantId)
    ?.options.find(option => option._id === variantOptionId);

  return { variantOption };
}
